var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25C10 6.91304 9.73661 7.54893 9.26777 8.01777C8.79893 8.48661 8.16304 8.75 7.5 8.75C6.83696 8.75 6.20107 8.48661 5.73223 8.01777C5.26339 7.54893 5 6.91304 5 6.25C5 5.58696 5.26339 4.95107 5.73223 4.48223C6.20107 4.01339 6.83696 3.75 7.5 3.75C8.16304 3.75 8.79893 4.01339 9.26777 4.48223C9.73661 4.95107 10 5.58696 10 6.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.245 13.745C3.91156 13.6112 1.25 10.8663 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75H7.41437C7.35771 13.75 7.30125 13.7483 7.245 13.745ZM3.48938 11.4437C3.44265 11.3096 3.42674 11.1666 3.44284 11.0254C3.45894 10.8842 3.50663 10.7484 3.58237 10.6282C3.65811 10.508 3.75996 10.4063 3.88035 10.3309C4.00074 10.2554 4.13659 10.208 4.27781 10.1922C6.71406 9.9225 8.30094 9.94687 10.7253 10.1978C10.8667 10.2125 11.0029 10.2593 11.1235 10.3347C11.2441 10.41 11.3459 10.5118 11.4212 10.6324C11.4965 10.753 11.5432 10.8892 11.5579 11.0306C11.5726 11.172 11.5548 11.3149 11.5059 11.4484C12.545 10.3972 13.1269 8.97812 13.125 7.5C13.125 4.39344 10.6066 1.875 7.5 1.875C4.39344 1.875 1.875 4.39344 1.875 7.5C1.875 9.03625 2.49094 10.4288 3.48938 11.4437Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3cc34374f9e5f634d31b8cf4035bfe97.svg";
export { ForwardRef as ReactComponent };